// Where the platforms deliver messages. A channel has its own url; Meta routers share one per environment
export const CHANNEL_WEBHOOK_BASE = {
  qa: "https://signpost-ia-app-qa.azurewebsites.net/channels",
  prod: "https://signpost-ia-app.azurewebsites.net/channels",
}

export const ROUTER_WEBHOOK = {
  qa: "https://signpost-ia-app-qa.azurewebsites.net/router",
  prod: "https://signpost-ia-app.azurewebsites.net/router",
}

export const channelWebhooks = (id: string) => ({
  qa: `${CHANNEL_WEBHOOK_BASE.qa}/${id}`,
  prod: `${CHANNEL_WEBHOOK_BASE.prod}/${id}`,
})
